<div class="modal__body" [ngStyle]="getStyles()">
  <span *ngIf="!blocking" class="modal__close" (click)="close()">
    <i class="icon-close"></i>
  </span>
	<ng-content>
	</ng-content>
</div>
<div class="modal__background" (click)="backgroundClick()"></div>
